import { render } from "./ValuationTypologyModal.vue?vue&type=template&id=22b1fa7d&ts=true"
import script from "./ValuationTypologyModal.vue?vue&type=script&lang=ts"
export * from "./ValuationTypologyModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__